import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import AdminLayout from "./components/AdminLayout";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import MyStoryPage from "./pages/MyStoryPage";
import ContactPage from "./pages/ContactPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminMyStory from "./pages/admin/AdminMyStory";
import AdminVideos from "./pages/admin/AdminVideos";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminArticles from "./pages/admin/AdminArticles";
import AdminGuides from "./pages/admin/AdminGuides";
import AdminAffiliateStats from "./pages/admin/AdminAffiliateStats";
import VideosPage from "./pages/VideosPage";
import JournalPage from "./pages/JournalPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import GuidesPage from "./pages/GuidesPage";
import "./App.css";

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/products" element={<PublicLayout><ProductsPage /></PublicLayout>} />
          <Route path="/products/:id" element={<PublicLayout><ProductDetailPage /></PublicLayout>} />
          <Route path="/my-story" element={<PublicLayout><MyStoryPage /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
          <Route path="/videos" element={<PublicLayout><VideosPage /></PublicLayout>} />
          <Route path="/jurnal" element={<PublicLayout><JournalPage /></PublicLayout>} />
          <Route path="/jurnal/:id" element={<PublicLayout><ArticleDetailPage /></PublicLayout>} />
          <Route path="/ghiduri" element={<PublicLayout><GuidesPage /></PublicLayout>} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
          <Route path="/admin/products" element={<AdminLayout><AdminProducts /></AdminLayout>} />
          <Route path="/admin/messages" element={<AdminLayout><AdminMessages /></AdminLayout>} />
          <Route path="/admin/testimonials" element={<AdminLayout><AdminTestimonials /></AdminLayout>} />
          <Route path="/admin/mystory" element={<AdminLayout><AdminMyStory /></AdminLayout>} />
          <Route path="/admin/videos" element={<AdminLayout><AdminVideos /></AdminLayout>} />
          <Route path="/admin/articles" element={<AdminLayout><AdminArticles /></AdminLayout>} />
          <Route path="/admin/guides" element={<AdminLayout><AdminGuides /></AdminLayout>} />
          <Route path="/admin/affiliate-stats" element={<AdminLayout><AdminAffiliateStats /></AdminLayout>} />
          <Route path="/admin/settings" element={<AdminLayout><AdminSettings /></AdminLayout>} />
          
          {/* Fallback */}
          <Route path="*" element={<PublicLayout><ProductsPage /></PublicLayout>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
